import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { PagedData } from '../models/paging/paged-data';
import { Page } from '../models/paging/page';
import { ServerData } from '../models/paging/server-data';

import { SnotifyService } from 'ng-snotify';
import { environment } from '../../environments/environment';
import { Manufacturer } from '../models/manufacturer';

@Injectable()
export class ManufacturerService {
  constructor(private http: HttpClient, private snotifyService: SnotifyService) { }

  public getByParent(parent_Manufacturer_Id: number): Promise<Manufacturer[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Manufacturer[]>(environment.apiUrl + 'manufacturer/getall?parent_Manufacturer_Id=' + parent_Manufacturer_Id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public getAll(): Promise<Manufacturer[]> {
    return new Promise((resolve, reject) => {
      this.http.get<Manufacturer[]>(environment.apiUrl + 'manufacturer/getall').subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public get(id: Number): Promise<Manufacturer> {
    return new Promise((resolve, reject) => {
      this.http.get<Manufacturer>(environment.apiUrl + 'manufacturer/get?id=' + id).subscribe(data => {
        resolve(data);
      }, error => {
        ////console.log(error);
        reject();
      });
    });
  }

  public save(manufacturer: Manufacturer): Promise<Manufacturer> {
    return new Promise((resolve, reject) => {
      if (manufacturer.is_edit) {
        this.http.put<Manufacturer>(environment.apiUrl + 'manufacturer/put', manufacturer).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully updated manufacturer');
        }, error => {
          ////console.log(error);
          reject();
        });
      } else {
        this.http.post<Manufacturer>(environment.apiUrl + 'manufacturer/post', manufacturer).subscribe(data => {
          resolve(data);
          this.snotifyService.success('Successfully added manufacturer');
        }, error => {
          ////console.log(error);
          reject();
        });
      }
    });
  }


  public getResults(page: Page, name: string): Promise<PagedData<Manufacturer>> {
    const pagedData = new PagedData<Manufacturer>();

    return new Promise((resolve, reject) => {
      if (page.sortBy == undefined || page.sortBy == '') { page.sortBy = 'Name'; }
      if (page.sortOrder == undefined || page.sortOrder == '') { page.sortOrder = 'asc'; }

      let params = '&name=' + name;

      this.http.get<ServerData>(environment.apiUrl + 'manufacturer/gettable?size=' + page.size + '&pageNumber=' + page.pageNumber + '&sortBy=' + page.sortBy + '&sortOrder=' + page.sortOrder + params).subscribe(data => {
        page.totalElements = data.totalElements;
        page.totalPages = page.totalElements / page.size;
        for (let i = 0; i < data.data.length; i++) {
          const jsonObj = data.data[i];
          pagedData.data.push(jsonObj);
        }

        pagedData.page = page;
        resolve(pagedData);

      }, error => {
        reject();
      });
    });


  }
}
